// Page-level memory for the typewriter loading screen. Several <LoadingScreen/>
// instances mount one after another on a cold load (the lazy-route Suspense
// fallback, then ProtectedRoute while auth loads), so the typing clock lives
// here, not in the component: a remount carries on where the last one was
// instead of starting again from "L". The masthead also reads it, so the
// paper is typed once per load, not twice.

/** A fast load shows nothing; the screen appears only after this long. */
export const LOADING_SHOW_AFTER_MS = 300;

let startedAt: number | null = null;
let typed = false;

const now = () => (typeof performance !== 'undefined' ? performance.now() : Date.now());

/** When the first loading screen of this page load mounted (set on first call). */
export function loadingStartedAt(): number {
  if (startedAt === null) startedAt = now();
  return startedAt;
}

/** Milliseconds since the first loading screen mounted. */
export function loadingElapsed(): number {
  return now() - loadingStartedAt();
}

/** Records that the loading screen became visible and typed its message. */
export function markLoadingTyped(): void {
  typed = true;
}

/** Whether the loading screen has already typed in this page load. */
export function loadingWasTyped(): boolean {
  return typed;
}

/** Test-only: forget the page load. */
export function resetLoadingType(): void {
  startedAt = null;
  typed = false;
}
